class SaveForLaterList extends HTMLElement {
  constructor() {
    super();
    this.listContainer = this.querySelector('.sfl-list');
    this.sfl = null;

    this.renderItems = this.renderItems.bind(this);
    this.handleSaveForLaterInitialized = this.handleSaveForLaterInitialized.bind(this);
  }

  connectedCallback() {
    if (!this.listContainer) {
      console.error('missing .sfl-list.');
      return;
    }
    document.addEventListener('EE:sfl:initialized', this.handleSaveForLaterInitialized);
  }

  disconnectedCallback() {
    document.removeEventListener('EE:sfl:initialized', this.handleSaveForLaterInitialized);
  }

  handleSaveForLaterInitialized() {
    this.sfl = window.SaveForLaterInstance;
    this.fetchAndRenderItems();
  }

  async fetchAndRenderItems() {
    try {
      const response = await this.sfl.fetchAll();
      if (response && response.items) {
        await this.renderItems(response.items);
        const initEvent = new CustomEvent('EE:sfl:ready', { bubbles: false });
        document.dispatchEvent(initEvent);
      } else {
        console.error('No items found in the SFL list.');
        this.listContainer.innerHTML = '<tr><td colspan="3">No items saved for later.</td></tr>';
      }
    } catch (error) {
      console.error('Error fetching SFL items:', error);
    }
  }

  async renderItems(items) {
    this.listContainer.innerHTML = '';

    const itemPromises = items.reverse().map(async (item) => {
      try {
        const productUrl = this.trimBaseUrl(item.du);
        const response = await fetch(`${window.Shopify.routes.root}${productUrl}&view=sfl-line-item`);
        if (response.ok) {
          const productRowHtml = await response.text();

          const parser = new DOMParser();
          const wrappedHtml = `<table>${productRowHtml}</table>`;
          const parsedDocument = parser.parseFromString(wrappedHtml, 'text/html');
          const rows = parsedDocument.querySelectorAll('tr');

          return rows;
        }
        console.error(`Failed to fetch ${item.handle}: ${response.status}`);
        return null;
      } catch (error) {
        console.error(`Error fetching ${item.handle}:`, error);
        return null;
      }
    });

    const rows = await Promise.all(itemPromises);
    rows.forEach((rowNodes) => {
      if (rowNodes) {
        rowNodes.forEach((node) => {
          this.listContainer.appendChild(node);
        });
      }
    });
  }

  // eslint-disable-next-line class-methods-use-this
  trimBaseUrl(url) {
    try {
      const parsedUrl = new URL(url);
      const trimmedUrl = parsedUrl.pathname + parsedUrl.search;
      return trimmedUrl.startsWith('/') ? trimmedUrl.slice(1) : trimmedUrl;
    } catch (error) {
      console.error('Invalid URL in trimBaseUrl:', url, error);
      return url;
    }
  }
}

customElements.define('save-for-later-list', SaveForLaterList);
